export default __webpack_public_path__ + "static/TIMBERLINE-L-SERIES-32-D-front-WEB-c69f53071dbe8f8a2af86f7ea98556f7.png";